import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import Toastify from 'toastify-js';
export default {
  init: function init() {
    $(".hamburger").on("click", function () {
      $(this).toggleClass("is-active");

      if ($(this).hasClass("is-active")) {
        $("body").addClass("menu-open");
        $('.nav-container').addClass('open').removeClass('width-hidden');
      } else {
        $("body").removeClass("menu-open");
        $('.nav-container').removeClass('open');
        setTimeout(function () {
          $('.nav-container').addClass('width-hidden');
        }, 300);
      }
    });
    $(window).resize(function () {
      $(".topnav").attr("style", "");
      $(".hamburger").removeClass("is-active");
      $('.nav-container').removeClass('open');

      if ($(window).width() > 1024) {
        $('.sub-menu').removeClass('open');
      }

      if ($(window).width() > 1024) {
        $('.nav-container').removeClass('width-hidden');
      }
    });

    if ($(window).width() <= 1024) {
      $('.nav-container').addClass('width-hidden');
    }

    $(window).on("scroll", function () {
      if ($(window).scrollTop() > 0) {
        $("header.header").addClass("fixed");
      } else {
        $("header.header").removeClass("fixed");
      }
    });
    var subMenuButton = $("<button class=\"submenu-button\" aria-expanded=\"false\" aria-controls=\"products-services-sub-menu\">\n\t\t\t<span>toggle submenu for About</span>\n\t\t</button>");
    $('.menu-item-has-children .sub-menu').before(subMenuButton);
    $('.submenu-button').on('click', function () {
      $(this).next().toggleClass('open');
    });
    /* SKIP LINKS */
    // skip link scroll to section

    var skipToAnchor = function skipToAnchor(aid) {
      var aTag = $(aid);
      var focus = true;
      $('html,body').animate({
        scrollTop: aTag.offset().top
      }, 'slow');
      var first_child = $(aTag.children()[0]);
      var tag = first_child.prop('tagName').toLowerCase();

      if (tag !== 'a' && tag !== 'button' && tag !== 'input' && tag !== 'textarea') {
        if (first_child.attr('tabIndex') !== undefined) {
          first_child.attr('tabIndex', -1).focus();
          first_child.removeAttr('tabIndex');
        } else {
          first_child.focus();
        }
      } else {
        first_child.focus();
      }
    }; // create skip links


    var skipLinks = function skipLinks() {
      $('section').each(function () {
        var id = $(this).attr('id');

        if (id !== undefined) {
          // Use the section id to create a label for the items in the skip link list
          var sectionNameArray = id.split('-');
          var sectionName = '';

          for (var i = 0; i < sectionNameArray.length; i++) {
            var str = sectionNameArray[i];
            str = str.toLowerCase().replace(/\b[a-z]/g, function (letter) {
              return letter.toUpperCase();
            });
            sectionName += str;

            if (i < sectionNameArray.length - 1) {
              sectionName += " ";
            }
          }

          var skiplink = "<li><a href='#" + id + "' class='text-link'>Skip to " + sectionName + "</a></li>";
          $('.skiplinks ul').append(skiplink);
        }
      });
      var skipLinkContainer = $('.skiplinks'),
          skipLink = $('.skiplinks a');
      skipLink.on('focus', function () {
        skipLinkContainer.addClass('show');
      });
      skipLink.on('blur', function () {
        skipLinkContainer.removeClass('show');
      });
      skipLink.on('click', function (e) {
        e.preventDefault();
        skipToAnchor($(this).attr('href'));
      });
    };

    skipLinks(); // Scroll To

    (function () {
      $(".scrollto").on("click", function (e) {
        e.preventDefault();
        var section = $(this).attr("href");
        $("html, body").animate({
          scrollTop: $(section).offset().top
        }, 1000);
      });
    })(); // faq flex module accordion


    var accordionBlocks = document.querySelectorAll('.faqs-block');

    if (accordionBlocks.length) {
      accordionBlocks.forEach(function (block) {
        var items = block.querySelectorAll('.faq-items');
        items.forEach(function (thisItem) {
          thisItem.addEventListener('click', function (e) {
            if (e.target.nodeName !== 'A' && e.target.nodeName !== 'SPAN') {
              e.preventDefault();
              items.forEach(function (otherItem) {
                if (otherItem !== thisItem) {
                  otherItem.classList.remove('active');
                }
              });
              thisItem.classList.toggle('active');
            }
          });
        });
      });
    } // Form
    // $("select").comboSelect();


    var sectionWaypoints = $("section").each(function () {
      $(this).waypoint({
        handler: function handler(direction) {
          var el = $(this.element);
          setTimeout(function () {
            el.addClass("loaded");
          }, 1000);
        },
        offset: "50%"
      });

      if ($(this).hasClass("scroll-group")) {
        console.log("adding scroll group waypoints");
        $(this).waypoint({
          handler: function handler(direction) {
            if (direction === "down") {
              $(this.element).addClass("fixed");
            } else {
              $(this.element).removeClass("fixed");
            }
          },
          offset: function offset() {
            return 100 + $("header.header").outerHeight();
          }
        });
        $(this).waypoint({
          handler: function handler(direction) {
            if (direction === "down") {
              var offset = $(this.element).find(".row:last-child").offset().top - $(this.element).offset().top;
              $(this.element).removeClass("fixed").addClass("fixed-bottom");
              $(this.element).find(".fixed-item").css({
                top: offset
              });
            } else {
              $(this.element).addClass("fixed").removeClass("fixed-bottom");
              $(this.element).find(".fixed-item").removeAttr("style");
            }
          },
          offset: function offset() {
            return $(this.element).height() * -1 + $(this.element).find(".row").last().outerHeight() + 100;
          }
        });
      }
    });
    var scrollGroupWaypoints = $("section.scroll-group .row-content").each(function () {
      $(this).waypoint({
        handler: function handler(direction) {
          $(this.element).addClass("loaded");
        },
        offset: "77%"
      });
    });
    $("section.count").find(".number").each(function () {
      var options = {};
      var $num = $(this);
      var start = $(this).data("start");
      var end = $(this).data("end");
      options.prefix = $(this).data("prefix") ? $(this).data("prefix") : "";
      options.suffix = $(this).data("suffix") ? $(this).data("suffix") : "";
      options.separator = $(this).data("separator") ? $(this).data("separator") : ",";
      options.decimal = $(this).data("decimal") ? $(this).data("decimal") : ".";
      var countAnim = new CountUp($num.attr("id"), start, end, 0, 2, options);
      var countWp = $(this).waypoint({
        handler: function handler(direction) {
          if (!countAnim.error) {
            countAnim.start();
          } else {
            console.log(countAnim.error);
          }
        },
        offset: "50%"
      });
    });
    var lastWidth = 1440;
    $(window).on("load resize", function () {
      if ($(window).width() > 960 && lastWidth <= 960) {
        $("section.cta-section .right-image [mask]").attr("mask", "url(#mask-desktop)");
      } else if ($(window).width() <= 960 && lastWidth > 960) {
        $("section.cta-section .right-image [mask]").attr("mask", "url(#mask-tablet)");
      }

      lastWidth = $(window).width();
    });
  },
  finalize: function finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $(".modal-btn").on("click", function () {
      var modal_id = $(this).attr('data-modal');
      $("#" + modal_id).addClass('open');
      $("body").addClass('no-scroll');
    });
    $('.modal .close, .modal .overlay').on('click', function () {
      $("body").removeClass('no-scroll');
      $(this).parents('.modal').removeClass('open');
    });

    if ($('.gallery-modal').length > 0) {
      var galleryModals = [];
      $('.gallery-modal').each(function () {
        var el = $(this);
        galleryModals.push(el);
      });
      var firstSlide = galleryModals[0];
      var lastSlide = galleryModals[galleryModals.length - 1];
      $(firstSlide).find('.gal-modal-button-prev').attr('disabled', true);
      $(lastSlide).find('.gal-modal-button-next').attr('disabled', true);
      $(".gal-modal-button-next:not([disabled])").on("click", function () {
        var last = $(this).parents('.gallery-modal');
        var current = last.next('.gallery-modal');
        var next = current.next('.gallery-modal');
        last.removeClass('open');
        current.addClass('open');
        $("body").addClass('no-scroll');
      });
      $(".gal-modal-button-prev:not([disabled])").on("click", function () {
        var current = $(this).parents('.gallery-modal');
        var last = current.prev('.gallery-modal');
        var next = current.next('.gallery-modal');
        last.addClass('open');
        current.removeClass('open');
        $("body").addClass('no-scroll');
      });
    } //Text Loading


    var lazyText = $("section h1, section h2, section h3, section p, section button-container, section ul").each(function () {
      var el = $(this);

      if (el.parents('section').attr('id') !== "banner") {
        el.addClass('lazy-load-text');
        el.waypoint({
          handler: function handler(direction) {
            el.addClass('load');
          },
          offset: "90%"
        });
      }
    });
    var lazyImages = $(".image-container, .images-container .image, .news-item .image").each(function () {
      var el = $(this);
      el.waypoint({
        handler: function handler(direction) {
          el.addClass('load');
        },
        offset: "90%"
      });
    }); //background gradients

    $('.gradient-background video')[0].play();
    $('.background-pause').on('click', function () {
      if ($(this).hasClass('is-paused')) {
        $(this).removeClass('is-paused');
        $('.gradient-background video')[0].play();
        $(this).find('span.sr-only').html('Pause Background');
      } else {
        $(this).addClass('is-paused');
        $('.gradient-background video')[0].pause();
        console.log($(this)[0].className);
        $(this).find('span.sr-only').html('Play Background');
      }
    }); // Share button

    var shareButtons = document.querySelectorAll(".btn.share");
    shareButtons.forEach(function (button) {
      button.addEventListener("click", /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
          var pageTitle, shareData;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  e.preventDefault();
                  pageTitle = document.querySelector("h1").innerText;
                  shareData = {
                    title: "Envisioning Justice RE:ACTION",
                    text: pageTitle,
                    url: window.location.href
                  }; // if native sharing exists (mobile)

                  if (!(typeof navigator.share !== "undefined")) {
                    _context.next = 15;
                    break;
                  }

                  _context.prev = 4;
                  _context.next = 7;
                  return navigator.share(shareData);

                case 7:
                  window.alert("shared!");
                  _context.next = 13;
                  break;

                case 10:
                  _context.prev = 10;
                  _context.t0 = _context["catch"](4);
                  console.error(_context.t0);

                case 13:
                  _context.next = 16;
                  break;

                case 15:
                  // If we're on desktop, let's just copy to keyboard
                  try {
                    navigator.clipboard.writeText(window.location.href);
                    Toastify({
                      text: "Page URL copied to clipboard",
                      duration: 3000,
                      close: false,
                      gravity: "bottom",
                      // `top` or `bottom`
                      position: "right",
                      // `left`, `center` or `right`
                      stopOnFocus: true,
                      // Prevents dismissing of toast on hover
                      style: {
                        border: "1px solid black",
                        borderRadius: "1rem",
                        background: "rgba(#FFC700, .38)",
                        backgroundImage: "none",
                        color: "black",
                        cursor: "default"
                      } // onClick: function(){} // Callback after click

                    }).showToast();
                  } catch (newError) {
                    console.error("could not copy text to clipboard ".concat(newError));
                    Toastify({
                      text: "Error: Could not copy page URL",
                      duration: 3000,
                      close: false,
                      gravity: "bottom",
                      // `top` or `bottom`
                      position: "right",
                      // `left`, `center` or `right`
                      stopOnFocus: true,
                      // Prevents dismissing of toast on hover
                      style: {
                        border: "1px solid black",
                        borderRadius: "1rem",
                        background: "rgba(#FF0000, .38)",
                        backgroundImage: "none",
                        color: "black",
                        cursor: "default"
                      } // onClick: function(){} // Callback after click

                    }).showToast();
                  }

                case 16:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[4, 10]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    });
    $('iframe[src*="youtube"]').each(function (i, el) {
      if (!$(el).parent().hasClass('iframe-wrapper')) {
        $(el).wrap('<div class="iframe-wrapper">');
        $(this).parents('.video-container').addClass('no-border');
      }

      $(el).removeAttr('height').removeAttr('width');
    });
  }
};


// WEBPACK FOOTER //
// ./scripts/routes/common.js